export default function reducer (state = {
  token: '',
  user: {},
  search: {
    query: '',
    results: []
  },
  navigation: {},
  loading: true,
  loadingIndicator: null,
  deepstream: null,
  activeRoute: '/',
  pageTitle: '',
  language: 'EN',
  sidebar: true,
  isMobile: false,
  toolbar: false,
  access: false,
  alert: {},
  auth: {
    username: '',
    password: ''
  },
  updated: Date.now()
}, action) {
  switch (action.type) {
    case 'DO_UPDATE': {
      return {
        ...state,
        updated: Date.now()
      }
    }
    case 'SET_ACCESS': {
      return {
        ...state,
        access: action.payload
      }
    }
    case 'SET_LANGUAGE': {
      return {
        ...state,
        language: action.payload
      }
    }
    case 'SET_PAGE_TITLE': {
      if (!action.payload) action.payload = ''
      return {
        ...state,
        pageTitle: action.payload
      }
    }
    case 'SET_BASIC_AUTH': {
      return {
        ...state,
        auth: action.payload
      }
    }
    case 'SET_MOBILE_STATE': {
      return {
        ...state,
        isMobile: action.payload
      }
    }
    case 'SET_NAVIGATION_PROPS': {
      return {
        ...state,
        navigation: action.payload
      }
    }
    case 'SET_SEARCH': {
      return {
        ...state,
        search: action.payload
      }
    }
    case 'SET_DEEPSTREAM_CLIENT': {
      return {
        ...state,
        deepstream: action.payload
      }
    }
    case 'SET_SIDEBAR_STATE': {
      return {
        ...state,
        sidebar: action.payload
      }
    }
    case 'SET_TOOLBAR_STATE': {
      return {
        ...state,
        toolbar: action.payload
      }
    }
    case 'ALERT_CLEAR': {
      return {
        ...state,
        alert: {}
      }
    }
    case 'ALERT_CREATE': {
      return {
        ...state,
        updated: Date.now(),
        alert: action.payload
      }
    }
    case 'SET_LOGIN': {
      return {
        ...state,
        token: action.payload.token,
        user: action.payload.user
      }
    }
    case 'SET_LOADING': {
      return {
        ...state,
        loading: action.payload
      }
    }
    case 'SET_LOADING_INDICATOR': {
      return {
        ...state,
        loadingIndicator: action.payload
      }
    }
    default: {
      return {
        ...state
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/reducers/siteReducer.js